import React from "react"
import * as styles from "./faqListContainer.module.scss"
import { FAQList } from "./faqList/faqList"

const FAQListContainer = ({ activeCategory }) => (
  <div className={styles.faqListContainer}>
    <FAQList activeCategory={activeCategory} />
  </div>
)

export default FAQListContainer
